export default `
  mutation (
    $code: String!,
    $code_description: String!,
    $articlesIds: [String],
    $tags: [ReportedTagInputType],
    $description: String,
    $photosDenounced: [String],
    $originModel: String,
    $product_id:String,
    $element_type:String,
    $source: String,
    $isFamily: Boolean,
    $familyId:String,
    $evidence_id: Int,
    $evidence_type: String,
    $design_registration_number: String,
    $design_protected_parts: String,
    $design_copied_parts: String,
  ) {
    reportArticles(reportedArticles: {
      articlesIds: $articlesIds
      tags: $tags
      code: $code
      description: $description
      code_description: $code_description
      photosDenounced: $photosDenounced
      originModel: $originModel,
      product_id: $product_id,
      element_type: $element_type,
      source: $source,
      isFamily: $isFamily,
      familyId: $familyId,
      evidence_id: $evidence_id,
      evidence_type: $evidence_type,
      design_registration_number: $design_registration_number,
      design_protected_parts: $design_protected_parts,
      design_copied_parts: $design_copied_parts,
    }) {
      articlesIds
    }
  }
`;